module.exports = __webpack_public_path__ + "files/1bdc8602cdab9fe22eda799433b40489.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-14.png
// module id = 1503
// module chunks = 60